import ProgramPreference from "../../../components/ProgramPreference";
import { forwardRef } from "react";
import {
  ProgramDetails,
  ProgramQuestionMap,
  Question,
  UploadSlot,
} from "../../../pages/Registration";
import CustomDropDown from "../CustomDropDown";
import BirthDatePicker from "../DatePicker";
import CommonDateTimePicker from "../DateTimePicker"; // Adjust the path if needed
import styles from "./index.module.scss";
import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, MenuItem, Select, TextField } from "@mui/material";
import VideoRecorder from "../VideoUpload";
import ProfileAddImg from "../../../assets/images/ProfileAdd.svg";
import PenEditIcon from "../../../assets/images/EditPen.svg";

import { getPrice } from "../../../utils/registrationUtils";
import parsePhoneNumberFromString, {
  isValidPhoneNumber,
} from "libphonenumber-js";
import PhoneInput from "react-phone-input-2";
import { highlightMahatriaAndInfinitheism } from "../HighlightMahatriaInfinitheism";
import { EMAIL_REGEX, PENDING_APPROVAL, SAVE_DRAFT, WARNING, WARNING_MESSAGES } from "../../../constants";
import CameraPopUp from "../CameraPopUp";
import CustomContent from "../../../components/CustomContent";
import { trimAndCapitalize } from "../../../utils/stringUtils";
import { getItemInLocalStorage } from "../../../services/localStorage";
import { calculateAge } from "../../../utils/commonFunctions";
import MultipleInput from "../MultipleInput";
import { phoneNumberType } from "../../../constants/urlConstants";

interface RenderFieldProps {
  pqm: ProgramQuestionMap;
  formData: Record<string, any>;
  errors: Record<string, { message: string; displayOrder: number , sectionOrder: number}>;
  handleFieldChange: (questionId: number, value: any, question: Question) => void;
  programDetails: ProgramDetails;
  addedclassName?: string;
  setFormData?: (data: Record<string, any>) => void;
  trigger: (...args: any[]) => void;
  handleMeetingDateChange: (date: Date | null) => void;
  handleTriggerValidation: () => void;
  handleKeyDown: (event: React.KeyboardEvent) => void;
  totalData?: any;
  basePrice?: string; // New prop for base price
  userStatus: any;
  handleFieldBlur: (question: Question, value: string , displayOrder : number , programQuestionFormSection : any) => void;
  showAlert: (show: boolean, message: string[], type: string, onReupload? : () => void) => void;
  bindingKeyHashMap: { [key: string]: number } | null;
  defaultgroupedAnswersData: {
    [key: number]: string;
  } | null;
  handleLoader: boolean;
  setModalDisplay: (display: boolean) => void;
  fieldChange: boolean;
  saveFormData: Record<string, any>;
  setErrors?: (errors: Record<string, { message: string; displayOrder: number , sectionOrder: number}>) => void;
  setRegistrationCountryCode: (code: string) => void;
  setIsSubmit: (isSubmit: boolean) => void;
  isSubmit?: boolean;
}

const mahatriaChoiceProgram = {
  id: "mahatria_choice",
  name: "Mahatria Choice",
  duration: "",
  dates: "",
};

const RenderField= forwardRef<HTMLDivElement, RenderFieldProps>(({
      pqm,
      formData,
      errors,
      handleFieldChange,
      programDetails,
      addedclassName = "",
      setFormData = () => { },
      totalData,
      basePrice,
      userStatus,
      handleFieldBlur,
      showAlert,
      bindingKeyHashMap,
      defaultgroupedAnswersData,
      handleLoader,
      setModalDisplay,
      fieldChange,
      saveFormData,
      setErrors,
      setRegistrationCountryCode,
      setIsSubmit,
      isSubmit = false,
    },
    ref,
  ) => {
    const seekerDetails = getItemInLocalStorage("seekerDetails");
    const userEditedRef = useRef<Record<number, boolean>>({});
    if (formData == undefined) {
      return null;
    }
    const reuploadMainFile = () => {
      const fileInput = document.getElementById(
        `banner-upload-${question.id}`,
      ) as HTMLInputElement;
      if (fileInput) {
        fileInput.click();
      }
    };

    const [selectedQuestionId, setSelectedQuestionId] = React.useState<
      number | null
    >(null);
    const [showImageCapturePopup, setShowImageCapturePopup] = useState(false);
    const previousQuestionIdRef = React.useRef<number | null>(null);
    const prevDependencySatisfiedRef = React.useRef<boolean | null>(null);
    const [previouslyOpenedVideoRef, setPreviouslyOpenedVideoRef] = useState<
      "finder" | "recorder" | ""
    >("");
    const [openRecorderForVideo, setOpenRecorderForVideo] =
      useState<boolean>(false);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [phoneValue, setPhoneValue] = useState<string>("");
    const phoneInputRef = useRef<HTMLInputElement | null>(null);
    const [isPrefilledAndDisabled, setIsPrefilledAndDisabled] = useState(false);
    const [recordedVideoBlob, setRecordedVideoBlob] =
      React.useState<Blob | null>(null);
    const [isValid, setIsValid] = React.useState<boolean>(false);
    const [isEmpty, setIsEmpty] = useState<boolean>(false);
    const prefillClearedRef = useRef<{ [questionId: number]: boolean }>({});
    useEffect(() => {
      // Only update if selectedQuestionId changed and is different from previous
      if (
        selectedQuestionId !== null &&
        selectedQuestionId !== previousQuestionIdRef.current
      ) {
        previousQuestionIdRef.current = selectedQuestionId;
        setFormData((prevData) => ({
          ...prevData,
          [selectedQuestionId]: "",
        }));
      }
    }, [selectedQuestionId, setFormData]);

    const areDependenciesSatisfied = (question: Question, formData: any) => {
      if (
        !question.config.dependsOn ||
        question.config.dependsOn.length === 0
      ) {
        return true;
      }

      return question.config.dependsOn.some((dep) => {
        if (dep?.type === "disable") {
          return true;
        } else if (dep.value == "notNull") {
          return (
            bindingKeyHashMap &&
            formData[bindingKeyHashMap[dep.questionBindingKey]] != undefined &&
            formData[bindingKeyHashMap[dep.questionBindingKey]] != null &&
            formData[bindingKeyHashMap[dep.questionBindingKey]] != ""
          );
        } else {
          const isMatch =
            bindingKeyHashMap &&
            ((formData[bindingKeyHashMap[dep.questionBindingKey]] ==
              dep.value &&
              !dep?.operator) ||
              (dep?.operator == "equals" &&
                Number(
                  formData[bindingKeyHashMap[dep.questionBindingKey]] ||
                    !dep?.value,
                ) == Number(dep.value)) ||
              (dep?.operator == "greaterThan" &&
                Number(formData[bindingKeyHashMap[dep.questionBindingKey]]) >
                  Number(dep.value)));
          let isDiffCondition = false;
          if (
            !dep?.value &&
            dep?.transformedMaxValue &&
            dep?.transformedMinValue &&
            bindingKeyHashMap
          ) {
            const ageDiff = calculateAge(
              formData[bindingKeyHashMap[dep.questionBindingKey]],
            );
            console.log(ageDiff, "ageDiff", programDetails);
            if (
              ageDiff < programDetails[dep?.transformedMinValue] ||
              ageDiff > programDetails[dep?.transformedMaxValue]
            ) {
              isDiffCondition = true;
            }
            return isDiffCondition;
          }

          if (!isMatch) {
            if (selectedQuestionId !== question.id) {
              setSelectedQuestionId(question.id);
            }
          }
          return isMatch;
        }
      });
    };

    const isDisabledSatisfied = (question: Question, formData: any) => {
      console.log("check question", question);

      if (
        !question.config.dependsOn ||
        question.config.dependsOn.length === 0
      ) {
        return true;
      }

      return question.config.dependsOn.some((dep) => {
        if (dep?.type !== "disable") {
          return true;
        } else if (dep.value == "notNull") {
          return (
            bindingKeyHashMap &&
            formData[bindingKeyHashMap[dep.questionBindingKey]] != undefined &&
            formData[bindingKeyHashMap[dep.questionBindingKey]] != null &&
            formData[bindingKeyHashMap[dep.questionBindingKey]] != ""
          );
        } else {
          const isMatch =
            bindingKeyHashMap &&
            ((formData[bindingKeyHashMap[dep.questionBindingKey]] ==
              dep.value &&
              !dep?.operator) ||
              (dep?.operator == "equals" &&
                Number(
                  formData[bindingKeyHashMap[dep.questionBindingKey]] ||
                    !dep?.value,
                ) == Number(dep.value)) ||
              (dep?.operator == "greaterThan" &&
                Number(formData[bindingKeyHashMap[dep.questionBindingKey]]) >
                  Number(dep.value)));
          if (
            !dep?.value &&
            dep?.transformedMaxValue &&
            dep?.transformedMinValue &&
            bindingKeyHashMap
          ) {
            const ageDiff = calculateAge(
              formData[bindingKeyHashMap[dep.questionBindingKey]],
            );
            if (
              ageDiff <= programDetails[dep?.transformedMinValue] ||
              ageDiff >= programDetails[dep?.transformedMaxValue]
            )
              isMatch = true;
          }

          if (!isMatch) {
            if (selectedQuestionId !== question.id) {
              setSelectedQuestionId(question.id);
            }
          }
          return isMatch;
        }
      });
    };

    const selectRef = useRef(null);
    const [menuWidth, setMenuWidth] = useState("auto");

    useEffect(() => {
      if (selectRef.current) {
        // Get the width of the Select component including padding
        const selectWidth = selectRef.current.offsetWidth;
        setMenuWidth(selectWidth);

        // Optional: Handle window resize
        const handleResize = () => {
          setMenuWidth(selectRef.current?.offsetWidth || "auto");
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }
    }, []);
    const [userClearedFields, setUserClearedFields] = useState<Set<number>>(
      new Set(),
    );
    // New useEffect to handle dependency changes and reset dependent field values
    useEffect(() => {
      const { question } = pqm;
      let prefillValue: any = "";
      const isDependencySatisfied = areDependenciesSatisfied(
        question,
        formData,
      );
      // Check if dependency satisfaction status changed
      if (
        prevDependencySatisfiedRef.current !== null &&
        prevDependencySatisfiedRef.current !== isDependencySatisfied
        // ||
        // (
        // prevDependencySatisfiedRef.current !== null &&
        //   prevDependencySatisfiedRef.current !== isDependencySatisfied
        // )
      ) {
        // If dependency is no longer satisfied, reset the field value
        if (!isDependencySatisfied && formData[question.id]) {
          handleFieldChange(question.id, "", question);
          // Clear the user edited and cleared flags when dependency changes
          userEditedRef.current[question.id] = false;
          setUserClearedFields((prev) => {
            const newSet = new Set(prev);
            newSet.delete(question.id);
            return newSet;
          });
          prefillClearedRef.current[question.id] = false;
        }
      }
      if (
        question.config.isDisable &&
        question.config.isDefaultValue &&
        isDependencySatisfied &&
        basePrice
      ) {
        handleFieldChange(question.id, basePrice, question);
      }

      // Handle prefill logic
      if (
        question.config?.prefill &&
        question.config.prefill.prefillIf &&
        question.config.prefill.prefillFrom
      ) {
        const shouldPrefill = question.config.prefill.prefillIf.some(
          (cond: any) => {
            if (
              totalData[2] &&
              bindingKeyHashMap &&
              totalData[2][bindingKeyHashMap[cond.questionBindingKey]] !=
                null &&
              totalData[2][bindingKeyHashMap[cond.questionBindingKey]] !=
                undefined
            ) {
              return (
                bindingKeyHashMap &&
                totalData[2][bindingKeyHashMap[cond.questionBindingKey]] ==
                  cond.value
              );
            }
          },
        );
        if (
          (totalData[1] &&
            totalData[1][question.config.prefill.prefillFrom] != null) ||
          totalData[1][question.config.prefill.prefillFrom] !== undefined
        ) {
          if (value === "" && isEmpty) {
            prefillValue = value;
          } else {
            prefillValue =
              value || totalData[1][question.config.prefill.prefillFrom];
            // Only prefill if the condition is met and the current value is empty
          }
          if (
            shouldPrefill &&
            isDependencySatisfied &&
            prefillValue !== undefined &&
            value !== prefillValue
            &&
            !userEditedRef.current[question.id] &&
            !userClearedFields.has(question.id)
          ) {
            handleFieldChange(question.id, prefillValue, question);
            prefillClearedRef.current[question.id] = false;
            setIsPrefilledAndDisabled(false);
          } else if (
            shouldPrefill &&
            isDependencySatisfied &&
            prefillValue !== undefined &&
            value === prefillValue &&
            !userClearedFields.has(question.id)
          ) {
            setIsPrefilledAndDisabled(false);
          } else if (
            !shouldPrefill &&
            formData[question.id] !== undefined &&
            formData[question.id] !== null &&
            !prefillClearedRef.current[question.id] &&
            fieldChange
          ) {
            setFormData((prev = {}) => ({
              ...prev,
              [2]: {
                ...(prev && prev[2] ? prev[2] : {}),
                [question.id]: "",
              },
            }));
            prefillClearedRef.current[question.id] = true;
            setIsPrefilledAndDisabled(false);
          } else {
            setIsPrefilledAndDisabled(false);
          }
          if (
            formData[question.id] !== undefined &&
            formData[question.id] !== "" &&
            formData[question.id] !== prefillValue &&
            !userClearedFields.has(question.id)
          ) {
            prefillClearedRef.current[question.id] = true;
            setIsPrefilledAndDisabled(false);
          }
        } else {
          setIsPrefilledAndDisabled(false);
        }
      } else if (
        question.config?.prefill &&
        question.config.prefill.prefillIf &&
        question.config?.prefill?.prefillType == "static"
      ) {
        const shouldPrefill = question.config.prefill.prefillIf.some(
          (cond: any) => {
            if (
              totalData[1] &&
              bindingKeyHashMap &&
              totalData[1][bindingKeyHashMap[cond.questionBindingKey]] !=
                null &&
              totalData[1][bindingKeyHashMap[cond.questionBindingKey]] !=
                undefined
            ) {
              return (
                bindingKeyHashMap &&
                cond.operator == "not_equals" &&
                totalData[1][bindingKeyHashMap[cond.questionBindingKey]] !=
                  cond.value
              );
            }
          },
        );

        // Only prefill if user hasn't cleared the field
        if (shouldPrefill && !userClearedFields.has(question.id)) {
          handleFieldChange(
            question.id,
            question.config.prefill.prefillValue,
            question,
          );
        }
      } else {
        setIsPrefilledAndDisabled(false);
      }

      // Update the previous dependency satisfaction status
      prevDependencySatisfiedRef.current = isDependencySatisfied;
    }, [formData]);

    const value = formData[pqm.question.id] || "";
    const { question, displayOrder, programQuestionFormSection } = pqm;
    const defaultValue = defaultgroupedAnswersData?.[question.id] || "";
    const error = errors[question.id]?.message;
    const inputClasses = `${styles.fieldInput} ${error ? styles.fieldInputError : ""} ${question.type == "select" ? styles.textTransform : ""}`;
    const inputSelectClasses = `${styles.fieldSelectInput} ${error ? styles.fieldInputError : ""} ${question.type == "select" ? styles.textTransform : ""}`;

    const getInputValue = () => {
      const { question } = pqm;

      // If no prefill config, return form value directly
      if (!question.config?.prefill) {
        return formData[pqm.question.id] || "";
      }

      const isDependencySatisfied = areDependenciesSatisfied(
        question,
        formData,
      );

      // Handle dynamic prefill
      if (
        question.config.prefill.prefillIf &&
        question.config.prefill.prefillFrom
      ) {
        const shouldPrefill = question.config.prefill.prefillIf.some((cond) => {
          if (
            totalData[2] &&
            bindingKeyHashMap &&
            totalData[2][bindingKeyHashMap[cond.questionBindingKey]] != null &&
            totalData[2][bindingKeyHashMap[cond.questionBindingKey]] !=
              undefined
          ) {
            return (
              bindingKeyHashMap &&
              totalData[2][bindingKeyHashMap[cond.questionBindingKey]] ==
                cond.value
            );
          }
          return false;
        });

        // Check if user has manually cleared/edited the field
        if (
          prefillClearedRef.current[question.id] ||
          userEditedRef.current[question.id] ||
          userClearedFields.has(question.id)
        ) {
          // IMPORTANT: Return the exact formData value, even if it's empty string
          return formData[pqm.question.id] !== undefined
            ? formData[pqm.question.id]
            : "";
        }

        // Only return prefilled value if conditions are met AND dependencies satisfied
        if (
          shouldPrefill &&
          isDependencySatisfied &&
          totalData[1]?.[question.config.prefill.prefillFrom]
        ) {
          // Check if formData has a value (including empty string)
          if (
            formData[pqm.question.id] !== undefined &&
            formData[pqm.question.id] !== null
          ) {
            return formData[pqm.question.id];
          }
          return totalData[1][question.config.prefill.prefillFrom];
        }

        // If conditions not met, return empty
        if (!shouldPrefill) {
          return "";
        }
      }

      // Handle static prefill
      if (
        question.config.prefill.prefillIf &&
        question.config.prefill.prefillType === "static"
      ) {
        const shouldPrefill = question.config.prefill.prefillIf.some((cond) => {
          if (
            totalData[1] &&
            bindingKeyHashMap &&
            totalData[1][bindingKeyHashMap[cond.questionBindingKey]] != null &&
            totalData[1][bindingKeyHashMap[cond.questionBindingKey]] !=
              undefined
          ) {
            return (
              bindingKeyHashMap &&
              cond.operator === "not_equals" &&
              totalData[1][bindingKeyHashMap[cond.questionBindingKey]] !=
                cond.value
            );
          }
          return false;
        });

        // Check if user has manually cleared/edited the field
        if (
          prefillClearedRef.current[question.id] ||
          userEditedRef.current[question.id] ||
          userClearedFields.has(question.id)
        ) {
          return formData[pqm.question.id] !== undefined
            ? formData[pqm.question.id]
            : "";
        }

        if (shouldPrefill) {
          // Check if formData has a value (including empty string)
          if (
            formData[pqm.question.id] !== undefined &&
            formData[pqm.question.id] !== null
          ) {
            return formData[pqm.question.id];
          }
          return question.config.prefill.prefillValue;
        }
      }

      // Default: return form value
      return formData[pqm.question.id] || "";
    };

    const conditionalValue = getInputValue();
    // Check if dependencies are satisfied before rendering
    if (!areDependenciesSatisfied(question, formData)) {
      return null;
    }

    switch (question.type) {
      case "tel": {
        const segregatePhoneNumber = value
          ? parsePhoneNumberFromString(value)
          : undefined;
        const initialCountryCode =
          segregatePhoneNumber?.countryCallingCode || "91";

        const [selectedCountryCode, setSelectedCountryCode] =
          useState(initialCountryCode);
        const phoneNumber = defaultgroupedAnswersData?.[question.id]
          ? parsePhoneNumberFromString(defaultgroupedAnswersData?.[question.id])
          : "" || "";
        const [phoneValue, setPhoneValue] = useState(
          segregatePhoneNumber?.number || `+${initialCountryCode}`,
        );
        const isDisabled = isDisabledSatisfied(question, formData);
        useEffect(() => {
          setRegistrationCountryCode(selectedCountryCode);
        }, [selectedCountryCode]);
        // Add useEffect to handle phone value changes based on isDisabledSatisfied
        useEffect(() => {
          // if(saveFormData[1][bindingKeyHashMap?.phoneNumberType] ===
          //   "Different number" && isValidPhoneNumber(phoneValue) && !isDisabled){
          //         setPhoneValue
          //   }

          if (
            isDisabled &&
            saveFormData[1][bindingKeyHashMap?.phoneNumberType] !==
              phoneNumberType?.differentNumber
          ) {
            if (!error) {
              if (!isSubmit) {
                setPhoneValue(`+91`);
                handleFieldChange(question.id, `+91`, question);
                if (isSubmit) {
                  setIsSubmit && setIsSubmit(false);
                }
              }
            }
          } else if (!isDisabled && seekerDetails?.phoneNumber) {
            const ProfilephoneNumber =
              seekerDetails?.countryCode + seekerDetails?.phoneNumber;
            setPhoneValue(ProfilephoneNumber);
            handleFieldChange(question.id, ProfilephoneNumber, question);
          } else {
            // Format phone number by removing + prefix if exists
            let phoneValueFormatted;

            if (
              phoneNumber?.number ||
              phoneNumber?.countryCallingCode !== undefined
            ) {
              setPhoneValue(
                phoneNumber?.number ||
                  `${phoneNumber?.countryCallingCode}` ||
                  "+91",
              );
              phoneValueFormatted =
                phoneNumber?.number ||
                `${phoneNumber?.countryCallingCode}` ||
                "+91";
            } else if (phoneValue) {
              phoneValueFormatted = phoneValue;
            } else {
              setPhoneValue("+91");
              phoneValueFormatted = "+91";
            }
            handleFieldChange(question.id, phoneValueFormatted, question);
          }
        }, [isDisabled]);

        useEffect(() => {
          if (segregatePhoneNumber?.countryCallingCode) {
            setSelectedCountryCode(segregatePhoneNumber.countryCallingCode);
          }
        }, [segregatePhoneNumber]);

        return (
          <div className={styles.fieldGroup} ref={ref}>
            <label className={styles.fieldLabel}>
              {highlightMahatriaAndInfinitheism(question.label)}
              {(question.config.isRequired === false ||
                question.config.isRequired === undefined ||
                question.config.isRequired === null) && (
                <span className={styles.optional}>(optional)</span>
              )}
            </label>
            <PhoneInput
              value={phoneValue}
              disabled={
                !isDisabledSatisfied(question, formData)
                  ? question.bindingKey == "mobileNumber" && defaultValue != ""
                    ? isValidPhoneNumber(phoneValue)
                      ? userStatus?.registrationStatus == SAVE_DRAFT
                        ? phoneValue === seekerDetails?.countryCode + seekerDetails?.phoneNumber ? true
                          : false
                        : true
                      : false
                    : false
                  : saveFormData[1][bindingKeyHashMap?.phoneNumberType] !==
                      phoneNumberType?.differentNumber
                    ? false
                    : !isValidPhoneNumber(phoneValue)
                      ? false
                      : userStatus?.registrationStatus == SAVE_DRAFT
                        ? false
                        : true
              }
              onChange={(phoneValue: string, countryData: any) => {
                if (countryData?.dialCode != selectedCountryCode) {
                  setPhoneValue(`+${countryData?.dialCode}`);
                } else {
                  console.log(phoneValue, "phoneValue");
                  setPhoneValue(phoneValue);
                }

                if (countryData?.dialCode) {
                  setSelectedCountryCode(countryData.dialCode);
                }
              }}
              onBlur={() => {
                const finalPhoneValue = phoneValue?.trim();
                if (!finalPhoneValue || finalPhoneValue === "+") {
                  const preservedValue = `+${selectedCountryCode}`;
                  handleFieldChange(question.id, preservedValue, question);
                  handleFieldBlur(
                    question,
                    preservedValue,
                    displayOrder,
                    programQuestionFormSection,
                  );
                  setPhoneValue(preservedValue); // Reflect in UI
                } else {
                  const valueToSet = finalPhoneValue.startsWith("+")
                    ? finalPhoneValue
                    : `+${finalPhoneValue}`;
                  handleFieldChange(question.id, valueToSet, question);
                  handleFieldBlur(
                    question,
                    valueToSet,
                    displayOrder,
                    programQuestionFormSection,
                  );
                }
              }}
              containerClass={styles.loginCustomContainer}
              inputClass={`${styles.loginCustomInput} `}
              buttonClass={`${styles.loginCustomButton} ${styles.disabledButton}`}
              dropdownClass={styles.loginCustomDropdown}
              enableSearch={true}
              disableSearchIcon={true}
              countryCodeEditable={false}
              inputProps={{
                readOnly: false,
                ref: phoneInputRef,
                onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
                  const input = e.target as HTMLInputElement;
                  const value = input.value;
                  const cursorPosition = input.selectionStart || 0;

                  const countryCodePattern = /^\+\d+\s?/;
                  const match = value.match(countryCodePattern);
                  const countryCodeEndPosition = match ? match[0].length : 0;

                  if (
                    (e.key === "Backspace" || e.key === "Delete") &&
                    cursorPosition <= countryCodeEndPosition
                  ) {
                    e.preventDefault();
                  }

                  if (e.key === "a" && (e.ctrlKey || e.metaKey)) {
                    e.preventDefault();
                    input.setSelectionRange(
                      countryCodeEndPosition,
                      value.length,
                    );
                  }
                },
                onSelect: (e: React.SyntheticEvent<HTMLInputElement>) => {
                  const input = e.target as HTMLInputElement;
                  const value = input.value;
                  const selectionStart = input.selectionStart || 0;

                  const countryCodePattern = /^\+\d+\s?/;
                  const match = value.match(countryCodePattern);
                  const countryCodeEndPosition = match ? match[0].length : 0;

                  if (selectionStart < countryCodeEndPosition) {
                    setTimeout(() => {
                      input.setSelectionRange(
                        countryCodeEndPosition,
                        input.selectionEnd || countryCodeEndPosition,
                      );
                    }, 0);
                  }
                },
              }}
              data-testid="phone-input"
            />
            {error && <p className={styles.fieldError}>{error}</p>}
          </div>
        );
      }
      case "draganddrop":
        return (
          <div className={styles.programPreferenceContainer} ref={ref}>
            <ProgramPreference
              availablePrograms={
                programDetails.type?.isGroupedProgram
                  ? programDetails.groupedPrograms
                  : programDetails?.sessions
              }
              maxPreferences={
                programDetails.type?.isGroupedProgram
                  ? programDetails.groupedPrograms.length
                  : programDetails?.sessions?.length
              }
              onPreferencesChange={(pref) => {
                handleFieldChange(
                  question.id,
                  pref != null
                    ? encodeURIComponent(JSON.stringify(pref))
                    : null,
                  question,
                );
              }}
              question={question}
              mahatriaChoice={mahatriaChoiceProgram}
              addedclassName={addedclassName}
              value={value != "" ? JSON.parse(decodeURIComponent(value)) : null}
            />
            {error && <p className={styles.fieldError}>{error}</p>}
          </div>
        );
      case "Address":
      case "textarea":
        return (
          <div key={question.id} className={styles.fieldGroup} ref={ref}>
            <label className={styles.fieldLabel}>
              {highlightMahatriaAndInfinitheism(question.label)}
              {(question.config.isRequired == false ||
                question.config.isRequired == undefined ||
                question.config.isRequired == null) && (
                <span className={styles.optional}>(optional)</span>
              )}
            </label>
            <textarea
              value={conditionalValue}
              onChange={(e) => {
                userEditedRef.current[question.id] = true;
                const maxChars = Number(question.config?.maxCharacters);
                let newValue = e.target.value.trimStart();

                if (newValue === "" && conditionalValue !== "") {
                  setUserClearedFields((prev) =>
                    new Set(prev).add(question.id),
                  );
                }

                if (maxChars && newValue.length > maxChars) {
                  newValue = newValue.slice(0, maxChars);
                }
                handleFieldChange(question.id, newValue, question);
              }}
              className={`${inputClasses} ${styles.textArea}`}
              onBlur={() =>
                handleFieldBlur(
                  question,
                  conditionalValue,
                  displayOrder,
                  programQuestionFormSection,
                )
              }
              disabled={isPrefilledAndDisabled}
              style={{
                cursor: isPrefilledAndDisabled ? "not-allowed" : "text",
              }}
            />
            <div className={styles.helperTextContainer}>
              {error && (
                <p className={`${styles.fieldError} ${styles.helperError}`}>
                  {error}
                </p>
              )}
              {question.config?.maxCharacters && (
                <p className={styles.charCount}>
                  {Number(question.config?.maxCharacters) -
                    conditionalValue.length}{" "}
                  characters left
                </p>
              )}
            </div>
          </div>
        );

      case "text":
      case "email":
      case "number":
        const isInputDisabled =
          question.bindingKey === "originalPayment" ||
          question.config?.isDisable ||
          (question.bindingKey == "email" &&
            defaultValue != "" &&
            EMAIL_REGEX.test(defaultValue) &&
            EMAIL_REGEX.test(value)) ||
          false;
        return (
          <div key={question.id} className={styles.fieldGroup} ref={ref}>
            <label className={styles.fieldLabel}>
              {typeof question.label === "string" &&
              /mahatria/i.test(question.label)
                ? question.label.split(/(mahatria)/gi).map((part, idx) =>
                    part.toLowerCase() === "mahatria" ? (
                      <span key={idx} className={styles.highlight}>
                        {highlightMahatriaAndInfinitheism(part)}
                      </span>
                    ) : (
                      highlightMahatriaAndInfinitheism(part)
                    ),
                  )
                : highlightMahatriaAndInfinitheism(question.label)}
              {(question.config.isRequired == false ||
                question.config.isRequired == undefined ||
                question.config.isRequired == null) && (
                <span className={styles.optional}>(optional)</span>
              )}
            </label>
            <input
              type={question.type}
              value={conditionalValue}
              placeholder={question.config?.placeholder || ""}
              min={
                question.type === "number"
                  ? question.bindingKey === "tdsAmount" ||
                    question.bindingKey === "chequeNo"
                    ? 1
                    : 0
                  : undefined
              }
              onChange={(e) => {
                userEditedRef.current[question.id] = true;
                let val = e.target.value.trimStart();
                if (val.length === 0) {
                  setIsEmpty(true);
                }
                // Trim and capitalize for gstNumber and tanNumber
                if (
                  question.bindingKey === "gstNumber" ||
                  question.bindingKey === "tanNumber" ||
                  question.bindingKey === "proFormaGstNumber"
                ) {
                  val = trimAndCapitalize(val);
                }

                if (
                  question.type === "number" &&
                  question.bindingKey === "tdsAmount"
                ) {
                  // Always allow clearing the field
                  if (val === "") {
                    handleFieldChange(question.id, val, question);
                    return;
                  }
                  // Only allow positive numbers (integer or decimal) >= 1
                  const num = Number(val);
                  if (!/^\d*\.?\d*$/.test(val) || isNaN(num) || num < 1) return;
                  handleFieldChange(question.id, val, question);
                  return;
                }
                // For other fields, just update as usual
                handleFieldChange(question.id, val, question);
              }}
              onKeyDown={(e) => {
                if (
                  question.type === "number" &&
                  question.bindingKey === "tdsAmount"
                ) {
                  if (
                    e.key === "-" ||
                    e.key === "+" ||
                    e.key === "e" ||
                    e.key === "E"
                  ) {
                    e.preventDefault();
                  }
                }
              }}
              onWheel={(e) => {
                if (question.type === "number") {
                  e.target.blur(); // Remove focus to prevent value change
                }
              }}
              className={`${inputClasses}${isInputDisabled || isPrefilledAndDisabled ? ` ${styles.fieldInputDisabled}` : ""}`}
              disabled={isInputDisabled || isPrefilledAndDisabled}
              style={{
                cursor:
                  isInputDisabled ||
                  isPrefilledAndDisabled ||
                  (question.bindingKey == "email" &&
                    defaultValue != "" &&
                    EMAIL_REGEX.test(defaultValue) &&
                    EMAIL_REGEX.test(value))
                    ? "not-allowed"
                    : "text",
              }}
              onBlur={() =>
                handleFieldBlur(
                  question,
                  conditionalValue,
                  displayOrder,
                  programQuestionFormSection,
                )
              }
            />
            {question.config.helperText && (
              <span className={styles.roommatePreference}>
                {question.config.helperText}
              </span>
            )}
            {error && <p className={styles.fieldError}>{error}</p>}
          </div>
        );

      case "date":
      const shouldShowTodaydefaultValue =
  question.bindingKey.includes("chequeDate") ||
  question?.bindingKey.includes("handOverDate") ||
  question?.bindingKey.includes("bankTransferDate");

const defaultDateValue = shouldShowTodaydefaultValue
  ? new Date()
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-")
  : undefined; // Change from "" to undefined
        return (
          <div key={question.id} className={styles.fieldGroup} ref={ref}>
            <label className={styles.fieldLabel}>
              {highlightMahatriaAndInfinitheism(question.label)}
              {(question.config.isRequired == false ||
                question.config.isRequired == undefined ||
                question.config.isRequired == null) && (
                <span className={styles.optional}>(optional)</span>
              )}
            </label>
            <BirthDatePicker
              value={value}
              onChange={(date) =>
                handleFieldChange(question.id, date, question)
              }
              config={question.config}
              defaultDateValue ={defaultDateValue}
              onBlur={() =>
                handleFieldBlur(
                  question,
                  value,
                  displayOrder,
                  programQuestionFormSection,
                )
              }
              allocatedProgram={userStatus?.allocatedProgram || null}
            />
            {error && <p className={styles.fieldError}>{error}</p>}
          </div>
        );

      case "select":
        return (
          <div key={question.id} className={styles.fieldGroup} ref={ref}>
            <label className={styles.fieldLabel}>
              {highlightMahatriaAndInfinitheism(question.label)}
              {(question.config.isRequired == false ||
                question.config.isRequired == undefined ||
                question.config.isRequired == null) && (
                <span className={styles.optional}>(optional)</span>
              )}
            </label>
            <CustomDropDown
              value={value}
              question={question}
              handleFieldChange={(id: string | number, val: string) =>
                handleFieldChange(Number(id), val, question)
              }
              inputClasses={inputSelectClasses}
              onBlur={() =>
                handleFieldBlur(
                  question,
                  value,
                  displayOrder,
                  programQuestionFormSection,
                )
              }
            />
            {error && <p className={styles.fieldError}>{error}</p>}
          </div>
        );

      case "apicall":
        // Determine if the Autocomplete should be disabled
        let disableAutocomplete = false;
        if (
          question.config?.prefill &&
          question.config.prefill.prefillIf &&
          question.config?.prefill?.prefillType === "static" &&
          question.bindingKey === "city"
        ) {
          const shouldPrefill = question.config.prefill.prefillIf.some(
            (cond: any) => {
              if (
                totalData[1] &&
                bindingKeyHashMap &&
                totalData[1][bindingKeyHashMap[cond.questionBindingKey]] !=
                  null &&
                totalData[1][bindingKeyHashMap[cond.questionBindingKey]] !=
                  undefined
              ) {
                return (
                  bindingKeyHashMap &&
                  cond.operator === "not_equals" &&
                  totalData[1][bindingKeyHashMap[cond.questionBindingKey]] !=
                    cond.value
                );
              }
              return false;
            },
          );
          if (shouldPrefill) {
            disableAutocomplete = true;
          }
        }
        return (
          <div key={question.id} className={styles.fieldGroup} ref={ref}>
            <label className={styles.fieldLabel}>
              {highlightMahatriaAndInfinitheism(question.label)}
              {(question.config.isRequired == false ||
                question.config.isRequired == undefined ||
                question.config.isRequired == null) && (
                <span className={styles.optional}>(optional)</span>
              )}
              {/* {question.config.isRequired && (
              <span className={styles.required}>*</span>
            )} */}
            </label>
            {/* <DropdownTextfield
            name = {question.label + question.id.toString()}
            label={question.label}
            options = {[{value: "9413", label: "sample"}, {value: "Other", label: "Other"}]}
            placeholder = "select"
            onValueChange = {(e)=>
              handleFieldChange(question.id, e.target.value as string, question)
            }
            error={error}
            value = {value}
          /> */}
            <Autocomplete
              disableClearable
              disabled={disableAutocomplete}
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "48px",
                  borderRadius: "0.375rem",
                  borderColor: "var(--gray-300)",
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "var(--gray-300)",
                  },
                  cursor: disableAutocomplete ? "not-allowed" : "pointer",
                },
                "& .MuiInputBase-input": {
                  cursor: disableAutocomplete ? "not-allowed" : "pointer",
                },
              }}
              options={question.questionOptionMaps.map((optionMap) => ({
                id: optionMap.option.id,
                name: optionMap.option.name,
              }))}
              getOptionLabel={(option) => option.name}
              value={
                question.questionOptionMaps
                  .map((optionMap) => ({
                    id: optionMap.option.id,
                    name: optionMap.option.name,
                  }))
                  .find((opt) => String(opt.id) === String(value)) || null
              }
              onChange={(_, newValue) => {
                handleFieldChange(
                  question.id,
                  newValue ? newValue.id?.toString() : "",
                  question,
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // label={question.label}
                  placeholder={`Select`}
                  className={inputSelectClasses}
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      cursor: disableAutocomplete ? "not-allowed" : "pointer",
                      "& input": {
                        cursor: disableAutocomplete ? "not-allowed" : "pointer",
                      },
                      "& input::placeholder": {
                        fontFamily: "Noto Sans",
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "gray", // Your desired color
                        opacity: 1, // Optional: ensures the color is applied
                      },
                    },
                  }}
                  // error={!!error}
                  // helperText={error}
                  onBlur={() =>
                    handleFieldBlur(
                      question,
                      value,
                      displayOrder,
                      programQuestionFormSection,
                    )
                  }
                />
              )}
              isOptionEqualToValue={(option, val) =>
                String(option.id) === String(val.id)
              }
            />
            {/* <Select
            onBlur={()=>handleFieldBlur(question, value)}
            className={inputClasses}
            id={`select-${question.id}`}
            value={value}
            // Generated by Copilot
            onChange={(e) =>
              handleFieldChange(question.id, e.target.value as string, question)
            }
            displayEmpty
            renderValue={(selected) => {
              if (!selected) {
                return (
                  <span style={{ color: "var(--gray-700)" }}>
                    Select {question.label}
                  </span>
                );
              }
              // Find the option name by id
              const selectedOption = question.questionOptionMaps.find(
                (optionMap) => String(optionMap.option.id) === String(selected),
              );
              return selectedOption ? selectedOption.option.name : "Lalitha";
            }}
            sx={{
              width: "100%",
              height: 48,
              padding: "0 0.75rem",
              border: "0.5px solid var(--gray-10)",
              borderRadius: "var(--border-radius-md)",
              fontSize: "16px",
              color: "var(--gray-700)",
              // transition: "var(--transition)",
              backgroundColor: "White",
              "&:hover": {
                backgroundColor: "transparent !important",
              },
              "&:focus": {
                outline: "none",
                borderColor: "var(--primary-blue)",
                boxShadow: "0 0 0 3px rgba(37, 99, 235, 0.1)",
              },
              ".MuiSelect-select": {
                paddingTop: 6,
                paddingBottom: 6,
                color: "#051B46",
                fontWeight: 400,
                lineHeight: 1.2,
                display: "flex",
                alignItems: "center",
                paddingLeft: "0px",
              },
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--gray-300)",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--gray-300)",
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 200,
                  borderRadius: "var(--border-radius-md)",
                  "& .MuiMenuItem-root:hover": {
                    backgroundColor: "var(--gray-300)",
                  },
                  "& .Mui-selected": {
                    backgroundColor: "var(--gray-300)",
                  },
                },
              },
            }}
          >
            <MenuItem value="" disabled>
              <p>Select {question.label}</p>
            </MenuItem>
            {question.questionOptionMaps.map((optionMap) => (
              <MenuItem
                key={optionMap.option.id}
                value={optionMap.option.id}
                sx={{
                  color: "#051B46",
                  fontSize: "16px",
                  fontWeight: 400,
                  fontFamily: "Noto Sans, sans-serif",
                }}
              >
                {optionMap.option.name}
              </MenuItem>
            ))}
          </Select>  */}
            {error && <p className={styles.fieldError}>{error}</p>}
          </div>
        );

      case "file":
        if (question.config.filetype === "video") {
          return (
            <div key={question.id} className={styles.fieldGroup}>
              <label className={styles.fieldLabel}>
                {highlightMahatriaAndInfinitheism(question.label)}
                {(question.config.isRequired == false ||
                  question.config.isRequired == undefined ||
                  question.config.isRequired == null) && (
                  <span className={styles.optional}>(optional)</span>
                )}
              </label>

              {formData[question.id] ? (
                <div className={styles.videoPreview}>
                  <div className={styles.videoThumbnailContainer}>
                    <video
                      className={styles.videoThumbnail}
                      src={formData[question.id]}
                      controls
                    />
                    <div className={styles.videoOverlay}>
                      <button
                        className={styles.deleteVideo}
                        onClick={() => {
                          handleFieldChange(question.id, null, question);
                        }}
                      ></button>
                      {formData[question.id] &&
                        previouslyOpenedVideoRef !== "" && (
                          <button
                            className={styles.editVideo}
                            onClick={() => {
                              if (previouslyOpenedVideoRef === "finder") {
                                if (fileInputRef.current) {
                                  fileInputRef.current.click();
                                }
                              } else if (
                                previouslyOpenedVideoRef === "recorder"
                              ) {
                                setOpenRecorderForVideo(true);
                              }
                            }}
                          >
                            {previouslyOpenedVideoRef === "finder" && (
                              <input
                                ref={fileInputRef}
                                type="file"
                                accept="video/*"
                                onChange={(e) => {
                                  const file = e.target.files?.[0];
                                  e.target.value = ""; // Clear the input value
                                  if (file) {
                                    if (!file.type.startsWith("video/")) {
                                      showAlert(
                                        true,
                                        WARNING_MESSAGES.UNSUPPORTED_VIDEO_TYPE,
                                        WARNING,
                                        reuploadMainFile,
                                      );
                                      return;
                                    }
                                    const url = URL.createObjectURL(file);
                                    const video =
                                      document.createElement("video");
                                    video.preload = "metadata";
                                    video.src = url;
                                    video.onloadedmetadata = () => {
                                      URL.revokeObjectURL(url);
                                      if (video.duration > 111) {
                                        // 111 in seconds
                                        showAlert(
                                          true,
                                          WARNING_MESSAGES.VIDEO_LENGTH_EXCEEDED,
                                          WARNING,
                                          reuploadMainFile,
                                        );
                                      } else if (file.size > 50 * 1024 * 1024) {
                                        // 100MB in bytes
                                        showAlert(
                                          true,
                                          WARNING_MESSAGES.VIDEO_SIZE_EXCEEDED,
                                          WARNING,
                                          reuploadMainFile,
                                        );
                                      } else {
                                        handleFieldChange(
                                          question.id,
                                          file,
                                          question,
                                        );
                                        setPreviouslyOpenedVideoRef("finder");
                                      }
                                    };
                                  }
                                }}
                                style={{ display: "none" }}
                              ></input>
                            )}
                            {previouslyOpenedVideoRef === "recorder" && (
                              <div style={{ width: "1px", opacity: 0 }}>
                                <VideoRecorder
                                  recordedVideoBlob={null}
                                  setRecordedVideoBlob={setRecordedVideoBlob}
                                  setIsValid={setIsValid}
                                  onFileDataUpload={(file: Blob) => {
                                    setPreviouslyOpenedVideoRef("recorder");
                                    handleFieldChange(
                                      question.id,
                                      file,
                                      question,
                                    );
                                    setOpenRecorderForVideo(false);
                                    // openRecorderForVideo = false
                                  }}
                                  openVideoRecorder={openRecorderForVideo}
                                />
                              </div>
                            )}
                          </button>
                        )}
                    </div>
                  </div>

                  <div className={styles.videoDetails}></div>
                </div>
              ) : (
                <div className={styles.videoUploadContainer}>
                  <div className={`${styles.uploadArea} ${styles.fileUpload}`}>
                    <input
                      type="file"
                      accept="video/*"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        e.target.value = "";
                        if (file) {
                          if (!file.type.startsWith("video/")) {
                            showAlert(
                              true,
                              WARNING_MESSAGES.UNSUPPORTED_VIDEO_TYPE,
                              WARNING,
                              reuploadMainFile,
                            );
                            return;
                          }
                          // Check video duration before uploading
                          const url = URL.createObjectURL(file);
                          const video = document.createElement("video");
                          video.preload = "metadata";
                          video.src = url;
                          video.onloadedmetadata = () => {
                            URL.revokeObjectURL(url);
                            if (video.duration > 111) {
                              // 111 in seconds
                              showAlert(
                                true,
                                WARNING_MESSAGES.VIDEO_LENGTH_EXCEEDED,
                                WARNING,
                                reuploadMainFile,
                              );
                            } else if (file.size > 50 * 1024 * 1024) {
                              // 100MB in bytes
                              showAlert(
                                true,
                                WARNING_MESSAGES.VIDEO_SIZE_EXCEEDED,
                                WARNING,
                                reuploadMainFile,
                              );
                            } else {
                              handleFieldChange(question.id, file, question);
                              setPreviouslyOpenedVideoRef("finder");
                            }
                          };
                        } else {
                          setPreviouslyOpenedVideoRef("finder");
                        }
                      }}
                      className={styles.fileInput}
                      id={`banner-upload-${question.id}`}
                    />
                    <label
                      htmlFor={`banner-upload-${question.id}`}
                      className={styles.uploadLabel}
                      style={formData[question.id] ? { padding: 0 } : undefined}
                    >
                      <div className={styles.uploadContent}>
                        <p className={styles.uploadText}>
                          {formData[`${question.id}`]
                            ? formData[`${question.id}`]
                            : "upload file here"}
                        </p>
                        <p className={styles.uploadInstructions}>
                          Please upload your video in
                          <br />
                          MP4 or MOV format (max size: <br /> upto 50MB & max
                          length: <br /> upto 111 secs).
                        </p>
                      </div>
                    </label>
                  </div>
                  <div className={styles.uploadOr}>
                    <div className={styles.verticalLine}></div>
                    <div>or</div>
                    <div className={styles.verticalLine}></div>
                  </div>
                  <div className={styles.videoRecorderContainer}>
                    <VideoRecorder
                      recordedVideoBlob={null}
                      setRecordedVideoBlob={setRecordedVideoBlob}
                      setIsValid={setIsValid}
                      onFileDataUpload={(file: Blob) => {
                        setPreviouslyOpenedVideoRef("recorder");
                        handleFieldChange(question.id, file, question);
                      }}
                    />
                  </div>
                </div>
              )}
              {error && (
                <p className={styles.fieldError} ref={ref}>
                  {error}
                </p>
              )}
            </div>
          );
        } else if (question.config.filetype === "profile") {
          return (
            <div key={question.id} className={styles.fieldGroup} ref={ref}>
              <label className={styles.fieldLabel}>
                {highlightMahatriaAndInfinitheism(question.label)}
                {(question.config.isRequired == false ||
                  question.config.isRequired == undefined ||
                  question.config.isRequired == null) && (
                  <span className={styles.optional}>(optional)</span>
                )}
              </label>
              <div className={styles.profileUploadArea}>
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  id={`profile-upload-${question.id}`}
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      handleFieldChange(question.id, file, question);
                    }
                  }}
                />
                <label
                  // htmlFor={`profile-upload-${question.id}`}
                  className={styles.profileUploadLabel}
                  onClick={(e) => {
                    e.preventDefault();
                    setShowImageCapturePopup(true);
                  }}
                >
                  <div className={styles.profileImageWrapper}>
                    <div className={styles.profileImage}>
                      <img
                        src={
                          formData[question.id]
                            ? formData[question.id]
                            : ProfileAddImg
                        }
                        alt="Profile"
                        // className={styles.profileImage}
                      />
                    </div>
                    {formData[question.id] && (
                      <img
                        src={PenEditIcon}
                        alt="Edit"
                        className={styles.penEditIcon}
                      />
                    )}
                  </div>
                </label>
                {showImageCapturePopup && (
                  <CameraPopUp
                    setShowImageCapturePopup={setShowImageCapturePopup}
                    onFileSelect={(file) =>
                      handleFieldChange(question.id, file, question)
                    }
                  />
                )}
              </div>
              {error && <p className={styles.fieldError}>{error}</p>}
            </div>
          );
        } else {
          return (
            <div key={question.id} className={styles.fieldGroup} ref={ref}>
              <UploadSlot
                label={question.label}
                uploadedFile={formData[question.id]}
                onFileChange={(file: File) => {
                  handleFieldChange(question.id, file, question);
                }}
              />
              {/*  } */}
              {error && <p className={styles.fieldError}>{error}</p>}
            </div>
          );
        }

      case "radio":
        return (
          <div key={question.id} className={styles.fieldGroup} ref={ref}>
            <label className={styles.fieldLabel}>
              {highlightMahatriaAndInfinitheism(question.label)}
              {(question.config.isRequired == false ||
                question.config.isRequired == undefined ||
                question.config.isRequired == null) && (
                <span className={styles.optional}>(optional)</span>
              )}
            </label>

            <div className={styles.radioGroup}>
              {question.questionOptionMaps.map((optionMap) => (
                <>
                  {getPrice(
                    userStatus,
                    formData,
                    optionMap.option.name,
                    bindingKeyHashMap,
                  ) && (
                    <div
                      key={optionMap.option.id}
                      className={styles.radioElement}
                    >
                      <input
                        type="radio"
                        name={question.bindingKey}
                        value={optionMap.option.name}
                        checked={value === optionMap.option.name}
                        disabled={
                          question.bindingKey === "phoneNumberType" &&
                          userStatus?.registrationStatus == PENDING_APPROVAL
                        }
                        onChange={(e) =>
                          handleFieldChange(
                            question.id,
                            e.target.value,
                            question,
                          )
                        }
                        className={styles.radioInput}
                      />
                      <label
                        className={styles.radioLabel}
                        onClick={(e) => {
                          if (
                            !(
                              question.bindingKey === "phoneNumberType" &&
                              userStatus?.registrationStatus == PENDING_APPROVAL
                            )
                          ) {
                            handleFieldChange(
                              question.id,
                              optionMap.option.name,
                              question,
                            );
                          }
                        }}
                      >
                        {optionMap.option.name}
                      </label>
                    </div>
                  )}
                </>
              ))}
            </div>
            {error && <p className={styles.fieldError}>{error}</p>}
            {
              <CustomContent
                formData={formData}
                pqm={pqm}
                allocatedProgram={userStatus?.allocatedProgram}
                isShowModal={handleLoader}
                setModalDisplay={setModalDisplay}
              />
            }
          </div>
        );

      case "checkbox":
        const checkboxValue = Array.isArray(value)
          ? value
          : value
            ? [value]
            : [];
        return (
          <div key={question.id} className={styles.fieldGroup} ref={ref}>
            <div className={styles.checkboxGroup}>
              {question.questionOptionMaps.map((optionMap) => (
                <label
                  key={optionMap.option.id}
                  className={styles.checkboxItem}
                >
                  <input
                    type="checkbox"
                    name={question.bindingKey}
                    value={optionMap.option.name}
                    checked={checkboxValue.includes(optionMap.option.name)}
                    onChange={(e) => {
                      const newValue = e.target.checked
                        ? [...checkboxValue, optionMap.option.name]
                        : checkboxValue.filter(
                            (v: string) => v !== optionMap.option.name,
                          );
                      handleFieldChange(question.id, newValue, question);
                    }}
                    className={styles.checkboxInput}
                  />
                  <span className={styles.fieldLabel}>
                    {highlightMahatriaAndInfinitheism(question.label)}
                  </span>
                </label>
              ))}
            </div>
            {error && <p className={styles.fieldError}>{error}</p>}
          </div>
        );

      case "dateandtime":
        return (
          <div className={`${styles.formRow} ${styles.fieldGroup}`} ref={ref}>
            <div className={styles.formRowContainer} data-testid="">
              <label className={styles.fieldLeftLabel}>
                {highlightMahatriaAndInfinitheism(question.label)}
                {(question.config.isRequired == false ||
                  question.config.isRequired == undefined ||
                  question.config.isRequired == null) && (
                  <span className={styles.optional}>(optional)</span>
                )}
              </label>
              <div className={styles.formFieldsContainer}>
                <div className={styles.timeFormFields}>
                  <CommonDateTimePicker
                    type="date"
                    value={value}
                    onChange={(date) => {
                      // handleFieldChange(question.id, date, question);
                    }}
                    onValueChange={(date) => {}}
                    startDate={new Date()}
                    borderRight={true}
                    errorExist={!!errors.meetingDate}
                    // onKeyDown={handleKeyDown}
                    dataTestId="set-date"
                    className={styles.formFieldMeeting}
                  />
                </div>

                {/* Meeting Start Time */}
                <div className={styles.timeFormFields}>
                  <CommonDateTimePicker
                    type="time"
                    value={value}
                    onChange={(time) => {
                      // handleFieldChange(question.id, time, question);
                    }}
                    errorExist={!!errors.meetingTime}
                    dataTestId="start-time-picker"
                    // onKeyDown={handleKeyDown}
                    className={styles.formFieldMeeting}
                  />
                </div>
              </div>
            </div>
            {error && <p className={styles.fieldError}>{error}</p>}
          </div>
        );

      case "yearRange": {
        const currentYear = new Date().getFullYear();
        const { minYear, maxYear, maxYearOffset, yearOffset }: any =
          question.config || {};
        let years: { value: string; label: string }[] = [];

        if (minYear === "current") {
          // For future years (current to current + 100)
          for (let y = currentYear + 100; y >= currentYear; y--) {
            years.push({
              value: `${y} - ${(y + 1).toString()}`,
              label: `${y} - ${(y + 1).toString()}`,
            });
          }
        } else if (maxYear === "current") {
          // For past years with offset
          const endYear = maxYearOffset
            ? currentYear + maxYearOffset
            : currentYear;
          const startYear = yearOffset ? yearOffset : currentYear - 100;

          for (let y = endYear; y >= startYear; y--) {
            const nextYear = y + 1;
            years.push({
              value: `${y} - ${nextYear.toString()}`,
              label: `${y} - ${nextYear.toString()}`,
            });
          }
        } else {
          // Default case
          const nextYear = currentYear + 1;
          years.push({
            value: `${currentYear} - ${nextYear.toString()}`,
            label: `${currentYear} - ${nextYear.toString()}`,
          });
        }

        return (
          <div key={question.id} className={styles.fieldGroup} ref={ref}>
            <label className={styles.fieldLabel}>
              {highlightMahatriaAndInfinitheism(question.label)}
              {question.config.isRequired == false && (
                <span className={styles.optional}>(optional)</span>
              )}
            </label>

            <div className={styles.selectWrapper}>
              <Select
                ref={selectRef}
                value={value}
                onChange={(e) =>
                  handleFieldChange(question.id, e.target.value, question)
                }
                onBlur={() =>
                  handleFieldBlur(
                    question,
                    value,
                    displayOrder,
                    programQuestionFormSection,
                  )
                }
                displayEmpty
                className={inputSelectClasses}
                id={`select-${question.id}`}
                renderValue={(selected) => {
                  if (!selected) {
                    return <span className={styles.selectValue}>Select</span>;
                  }
                  return selected;
                }}
                sx={{
                  width: "100%",
                  height: 48,
                  border: "0.5px solid var(--gray-10)",
                  borderRadius: "var(--border-radius-md)",
                  fontSize: "16px",
                  color: "var(--gray-700)",
                  backgroundColor: "White",
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                  "&:focus": {
                    outline: "none",
                    borderColor: "var(--primary-blue)",
                    boxShadow: "0 0 0 3px rgba(37, 99, 235, 0.1)",
                  },
                  ".MuiSelect-select": {
                    padding: "12.5px 14px !important",
                    paddingRight: value ? "45px !important" : "14px !important", // Add space for X button when value exists
                    color: "#051B46",
                    fontWeight: 400,
                    lineHeight: 1.2,
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "15px",
                  },
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: "var(--gray-300)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "var(--gray-300)",
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      width: menuWidth,
                      maxHeight: 200,
                      borderRadius: "var(--border-radius-md)",
                      "& .MuiMenuItem-root:hover": {
                        backgroundColor: "var(--gray-300)",
                      },
                      "& .Mui-selected": {
                        backgroundColor: "var(--gray-300)",
                      },
                    },
                  },
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                }}
              >
                <MenuItem value="" disabled>
                  <span className={styles.selectValue}>Select</span>
                </MenuItem>
                {years.map((yearOption) => (
                  <MenuItem
                    key={yearOption.value}
                    value={yearOption.value}
                    className={styles.selectItem}
                    sx={{
                      color: "#051B46",
                      fontSize: "16px",
                      fontWeight: 400,
                      fontFamily: "Noto Sans, sans-serif",
                    }}
                  >
                    {yearOption.label}
                  </MenuItem>
                ))}
              </Select>

              {/* Clear (X) Button */}
              {value && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent opening the select dropdown
                    handleFieldChange(question.id, "", question); // Clear the value
                  }}
                  className={styles.clearButton}
                >
                  ×
                </button>
              )}
            </div>

            {error && <p className={styles.fieldError}>{error}</p>}
          </div>
        );
      }
      case "year": {
        const currentYear = new Date().getFullYear();
        const { minYear, maxYear, maxYearOffset, yearOffset }: any =
          question.config || {};
        let years: { value: string; label: string }[] = [];

        if (minYear === "current") {
          // For future years (current to current + 100)
          for (let y = currentYear + 100; y >= currentYear; y--) {
            years.push({
              value: `${y}`,
              label: `${y}`,
            });
          }
        } else if (maxYear === "current") {
          // For past years with offset
          const endYear = maxYearOffset
            ? currentYear + maxYearOffset
            : currentYear;
          const startYear = yearOffset ? yearOffset : currentYear - 100;

          for (let y = endYear; y >= startYear; y--) {
            years.push({
              value: `${y}`,
              label: `${y}`,
            });
          }
        } else {
          // Default case
          years.push({
            value: `${currentYear}`,
            label: `${currentYear}`,
          });
        }

        return (
          <div key={question.id} className={styles.fieldGroup} ref={ref}>
            <label className={styles.fieldLabel}>
              {highlightMahatriaAndInfinitheism(question.label)}
              {(question.config.isRequired == false ||
                question.config.isRequired == undefined ||
                question.config.isRequired == null) && (
                <span className={styles.optional}>(optional)</span>
              )}
            </label>
            {/* <SelectTag
            value={value}
            onValueChange={(val) => handleFieldChange(question.id, val, question)}
            matchTriggerWidth={true}
          >
            <SelectTrigger className={styles.selectTrigger}>
              <SelectValue
                placeholder="Select year"
                className={styles.selectValue}
              />
            </SelectTrigger>
            <SelectContent className={styles.selectContent}>
              {years.map((yearOption) => (
                <SelectItem
                  key={yearOption.value}
                  value={yearOption.value}
                  className={styles.selectItem}
                >
                  {yearOption.label}
                </SelectItem>
              ))}
            </SelectContent>
          </SelectTag> */}
            <div className={styles.selectWrapper}>
              <Select
                value={value}
                ref={selectRef}
                onChange={(e) =>
                  handleFieldChange(question.id, e.target.value, question)
                }
                onBlur={() =>
                  handleFieldBlur(
                    question,
                    value,
                    displayOrder,
                    programQuestionFormSection,
                  )
                }
                displayEmpty
                className={inputSelectClasses}
                id={`select-${question.id}`}
                renderValue={(selected) => {
                  if (!selected) {
                    return <span className={styles.selectValue}>Select</span>;
                  }
                  return selected;
                }}
                sx={{
                  width: "100%",
                  height: 48,
                  border: "0.5px solid var(--gray-10)",
                  borderRadius: "var(--border-radius-md)",
                  fontSize: "16px",
                  color: "var(--gray-700)",
                  backgroundColor: "White",
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                  "&:focus": {
                    outline: "none",
                    borderColor: "var(--primary-blue)",
                    boxShadow: "0 0 0 3px rgba(37, 99, 235, 0.1)",
                  },
                  ".MuiSelect-select": {
                    padding: "12.5px 14px !important",
                    color: "#051B46",
                    fontWeight: 400,
                    lineHeight: 1.2,
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "15px",
                  },
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: "var(--gray-300)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "var(--gray-300)",
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      width: menuWidth,
                      minWidth: "unset !important",
                      maxHeight: 200,
                      borderRadius: "var(--border-radius-md)",
                      "& .MuiMenuItem-root:hover": {
                        backgroundColor: "var(--gray-300)",
                      },
                      "& .Mui-selected": {
                        backgroundColor: "var(--gray-300)",
                      },
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  <span className={styles.selectValue}>Select</span>
                </MenuItem>
                {years.map((yearOption) => (
                  <MenuItem
                    key={yearOption.value}
                    value={yearOption.value}
                    className={styles.selectItem}
                    sx={{
                      color: "#051B46",
                      fontSize: "16px",
                      fontWeight: 400,
                      fontFamily: "Noto Sans, sans-serif",
                    }}
                  >
                    {yearOption.label}
                  </MenuItem>
                ))}
              </Select>
              {value && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent opening the select dropdown
                    handleFieldChange(question.id, "", question); // Clear the value
                  }}
                  className={styles.clearButton}
                >
                  ×
                </button>
              )}
            </div>
            {error && <p className={styles.fieldError}>{error}</p>}
          </div>
        );
      }
      case "multiQuestion": {
        return (
          <div key={question.id} className={styles.fieldGroup} ref={ref}>
            <label className={styles.fieldLabel}>
              {highlightMahatriaAndInfinitheism(question.label)}
            </label>

            <MultipleInput
              pqm={pqm}
              value={value}
              onChange={(parentQuestionId, value) =>
                handleFieldChange(parentQuestionId, value, question)
              }
              inputClassName={inputClasses}
              textAreaClassName={styles.textArea}
              error={error}
              helperText={question.config?.helperText}
              onBlur={() =>
                handleFieldBlur(
                  question,
                  value,
                  displayOrder,
                  programQuestionFormSection,
                )
              }
            />
          </div>
        );
      }
      default:
        return null;
    }
  },
);
RenderField.displayName = "RenderField";

export default RenderField;
